import * as index from './index';
index.ProgressBar.Inject(index.ProgressAnnotation, index.ProgressTooltip);
export * from './index';
